import styled, { keyframes } from "styled-components";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-12px); }
`;

const shimmer = keyframes`
  0% { left: -100%; }
  100% { left: 100%; }
`;

const pulse = keyframes`
  0%, 100% { opacity: 0.6; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.05); }
`;

export const LoginWrapper = styled.div`
  background: linear-gradient(135deg, #024995 0%, #009bd9 60%, #024995 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  /*
    Respiro fixo em cima e embaixo: sem isso o card encosta na borda quando cresce
    (modo recuperação, mensagem de sucesso). box-sizing faz o padding caber dentro
    dos 100vh, então não cria barra de rolagem à toa em tela grande.
  */
  padding: 40px 20px;
  box-sizing: border-box;
  color: #fff;
  position: relative;
  /* Só no eixo X, para conter o orb decorativo sem travar a rolagem vertical */
  overflow-x: hidden;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

  /* Grid pattern overlay */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image:
      linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px);
    background-size: 50px 50px;
    pointer-events: none;
  }

  /* Glowing orb top-right */
  &::after {
    content: '';
    position: absolute;
    top: -120px;
    right: -120px;
    width: 400px;
    height: 400px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(0,155,217,0.45) 0%, transparent 70%);
    pointer-events: none;
    animation: ${pulse} 5s ease-in-out infinite;
  }

  img {
    max-width: 220px;
    margin-bottom: 28px;
    filter: drop-shadow(0 8px 24px rgba(0,0,0,0.3));
    position: relative;
    z-index: 1;
  }
`;


export const FromWrapper = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 420px;
  color: #024995;
  border-radius: 24px;
  padding: 40px 36px 32px;
  text-align: center;
  box-shadow:
    0 32px 80px rgba(2, 73, 149, 0.25),
    0 8px 24px rgba(0, 0, 0, 0.1);
  animation: ${fadeInUp} 0.6s ease-out both;
  position: relative;
  z-index: 1;

  h1 {
    font-size: 26px;
    margin: 0 0 28px 0;
    padding: 0;
    text-transform: uppercase;
    font-weight: 800;
    letter-spacing: 3px;
    background: linear-gradient(135deg, #024995 0%, #009bd9 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

export const InputGroup = styled.div`
  position: relative;
  margin-bottom: 16px;
  text-align: left;

  label {
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #024995;
    margin-bottom: 6px;
    padding-left: 4px;
  }

  input {
    width: 100%;
    border: 2px solid #e8eef5;
    border-radius: 12px;
    padding: 14px 16px;
    font-size: 15px;
    background: #f5f8fc;
    color: #1a2740;
    transition: all 0.25s ease;
    outline: none;
    box-sizing: border-box;
    font-family: inherit;

    &::placeholder {
      color: #aab4c4;
    }

    &:focus {
      border-color: #009bd9;
      background: #fff;
      box-shadow: 0 0 0 4px rgba(0, 155, 217, 0.12);
    }
  }
`;

export const LoginButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #f39200 0%, #ffb347 100%);
  color: #fff;
  border: none;
  padding: 15px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  font-family: inherit;
  box-shadow: 0 6px 20px rgba(243, 146, 0, 0.4);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    transition: left 0.5s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 28px rgba(243, 146, 0, 0.5);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 12px rgba(243, 146, 0, 0.4);
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  /* Colado no que vem logo abaixo (link ou form de recuperação) */
  margin: 24px 0 10px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e8eef5;
  }

  span {
    font-size: 12px;
    color: #aab4c4;
    font-weight: 500;
    white-space: nowrap;
  }
`;

export const RecoverText = styled.p`
  font-size: 13px;
  color: #7a8fa6;
  margin: 0;
  animation: ${fadeInUp} 0.8s ease-out 0.2s both;
  position: relative;
  z-index: 1;

  strong {
    color: #f39200;
    cursor: pointer;
    font-weight: 700;
    transition: color 0.2s ease;

    &:hover {
      color: #024995;
    }
  }
`;

/*
  Fica dentro do card branco, então herda o visual dos campos de login
  (antes era translúcido, porque renderizava sobre o fundo azul).
*/
export const RecoverHint = styled.p`
  font-size: 13px;
  line-height: 1.6;
  color: #7a8fa6;
  text-align: center;
  margin: -12px 0 22px;
`;

export const RecoverForm = styled.div`
  animation: ${fadeInUp} 0.35s ease-out both;
  text-align: left;

  /* O último InputGroup do form não precisa do espaçamento de baixo */
  > form > div:last-of-type {
    margin-bottom: 0;
  }

  input:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const RecoverButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #024995 0%, #009bd9 100%);
  color: #fff;
  border: none;
  padding: 14px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: 14px;
  transition: all 0.3s ease;
  font-family: inherit;
  box-shadow: 0 6px 18px rgba(2, 73, 149, 0.3);

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(2, 73, 149, 0.42);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

export const CancelButton = styled.button`
  width: 100%;
  background: none;
  border: none;
  color: #7a8fa6;
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  margin-top: 10px;
  padding: 4px;
  transition: color 0.2s ease;

  &:hover:not(:disabled) {
    color: #024995;
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Aviso = styled.p`
  background: #fff4e5;
  border: 1px solid #ffd8a8;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.5;
  color: #a35b00;
  margin: 16px 0 0;
  text-align: center;
  animation: ${fadeInUp} 0.3s ease-out both;
`;

export const SuccessMessage = styled.p`
  background: #eafaf1;
  border: 1px solid #b7e4c7;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.5;
  color: #1b7a4b;
  margin: 16px 0 0;
  text-align: center;
  animation: ${fadeInUp} 0.35s ease-out both;

  strong {
    display: block;
    font-weight: 700;
    margin-bottom: 2px;
  }
`;
